import { Box} from "@chakra-ui/react";
import ClientContainer from "views/Customers/CustomerList/ClientContainer";
import CustomerList from "views/Customers/CustomerList/customerList";
import ProductContainer from "views/Products/ProductContainer";

const Products = ({}) => {
  return (
    < >
   <ProductContainer/>
    </>
  );
};

export default Products;
